import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';




@Component({
  selector: 'app-customer-outstanding-report',
  templateUrl: './customer-outstanding-report.component.html',
  styleUrls: ['./customer-outstanding-report.component.css']
})
export class CustomerOutstandingReportComponent implements OnInit {
  @ViewChild('cusBalReport', {static: false}) cusBalReport: ElementRef; 

  isDark: boolean = false;
  searchKey : string;

  invoiceList : any[]=[];
  filteredTypeList : any[]=[];
  filteredByNameList : any[]=[];
  filteredFinalList: any[]=[];

  inputToday = new Date();


  constructor(
              private invoiceService : InvoiceService, 
              private router : Router, 
              private themeService: NbThemeService,
               private decimalPipe: DecimalPipe
             ) { }

    ngOnInit() {

      this.getAllInvoices();
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
            
    }

    convertToFloat(val){
      return parseFloat(val);
    }

    getDayDiffrence(inputDate,pmtType,status){
      if(pmtType!=='Cash' && status!=='Paid'){
          const oneDay = 1000 * 3600 * 24;
          var today  = new Date();
          var invoiceDate  = new Date(inputDate);
          var diffInTime = today.getTime() - invoiceDate.getTime() ;

          const diffDays = Math.round(diffInTime /oneDay);
          return diffDays +' Days';
       }
    }
   
  

  getAllInvoices(){
    this.invoiceService.getAll()
     .subscribe(
        (data) => {
                  this.invoiceList = data;  
                  this.filteredFinalList = this.invoiceList; 
                  this.filteredTypeList  = this.invoiceList;              
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

  
     checkedChangeRdoButtons(event){
       if(event.value =="All"){
        this.filteredTypeList = this.invoiceList;
        this.filteredFinalList =  this.filteredTypeList;
       }
       else if(event.value =="Paid"){
        this.filteredTypeList = this.invoiceList.filter((el)=>{
          return el.Status ===event.value;
        });  
        this.filteredFinalList =  this.filteredTypeList;
       }
       else if(event.value =="Unpaid"){
        this.filteredTypeList = this.invoiceList.filter((el)=>{
          return el.Status ===event.value;
        });
        this.filteredFinalList =  this.filteredTypeList;
      }
     }


    getTotalBalance(){
      return this.filteredFinalList.map(totalBal=>totalBal.BalToPay).reduce((acc,value)=>acc + +value,0);
    }

    applyFilter(){
      this.filteredByNameList = this.filteredTypeList.filter((el)=>{
         return el.GuestName.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1;
       });
       this.filteredFinalList =  this.filteredByNameList;
     }
     
     onSearchClear(){
       this.searchKey = "";
       this.applyFilter();
     }

     invoiceData  =[{'name': 'Camera','price': 3200,'qty': 1},
                    {'name': 'UPS','price': 5000,'qty': 2}];

      savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Customer Outstanding Report', style: 'reportHeader' }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*',  'auto', 'auto', 'auto', 'auto'],  
                body: [  
                  ['InvoiceNo', 'InvoiceDate', 'GuestName','Status', 'InvoiceTotal', 'AmountPaid', 'Balance'],
                  ...this.filteredFinalList.map(p => ([p.InvoiceNo, moment(p.InvoiceDate).format("YYYY-MM-DD"), p.GuestName,  p.Status, {text : this.transformNumberFormat(p.GrandTotal), alignment: 'right'  }, { text : this.transformNumberFormat(p.AmountPaid),alignment: 'right'  }, { text: this.transformNumberFormat(p.BalToPay),alignment: 'right' }])),  
                  [ { text: 'Total balance due', bold: true, colSpan: 6 }, {},{},{},{},{},{ text :  this.transformNumberFormat(this.getTotalBalance()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('cusBalReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Customer Outstanding Report.xlsx');
       
     }

     transformNumberFormat(number) {
         return this.decimalPipe.transform(number,'1.2-2');
      }

convertDateToMySql(date){
  var getDate = null;
  if(date){
  var dateInput = new Date(date);
  var year = String(dateInput.getFullYear());
  var month = String(dateInput.getMonth() + 1);
  var day = String(dateInput.getDate());
  if(month.length==1){
    month = "0" + month;
  }
  if(day.length==1){
    day = "0" + day;
  }

  getDate =  year+"-"+month+"-"+day; 

  }
  return getDate;
}



}
